export const bg = {
  ADD_COLOR_STRING_KEY: 'Добави цвят',
  ADD_TEXT_KEY: 'Добавете текст',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Добавете в кошницата',
  ADD_TEMPLATE: 'Добави шаблон',
  ADJUST_SIZE_KEY: 'Нагласи размера',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    'Като кликнете на "Готово", се съгласявате с условията за употреба на HP и изявлението за поверителност.',
  ALIGN_BOTTOM_KEY: 'Подравняване отдолу',
  ALIGN_CENTER_KEY: 'центриране',
  ALIGN_KEY: 'подравняване',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'подравнете средата',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Подравняване отгоре',
  ALL_TAB_TITLE_KEY: 'Всички',
  ALMOST_DONE_TITLE_KEY: 'Почти готово!',
  AND_KEY: 'и',
  APPLY_KEY: 'Приложи',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Разгледайте съдържанието и изберете изображения за дизайна си или качете свои.',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Прегледайте дизайна си и изпипайте подробностите',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Персонализирайте дизайна и добавете други елементи към проекта си',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'Когато дизайнът е готов, кликнете на СЛЕДВАЩ, за да направите последна проверка и да направите поръчката.',
  BACK_KEY: 'Назад',
  BACKGROUND_KEY: 'Фон',
  BACKGROUND_UPPER_CASE_KEY: 'ФОН',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'Не са намерени вдъхновения в тази категория',
  BRING_TO_FRONT_KEY: 'Изведи напред',
  CANCEL_TEXT_KEY: ' Отмени ',
  CENTIMETERS_KEY: 'сантиметра',
  CM_KEY: 'см.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Изберете от компютъра',
  CHOOSE_RIP_OPTIONS:
    'Изберете от тези съвместими растерни процесори на изображения (RIP) от трети страни',
  CHOOSE_FILE_KEY: 'Избери файл',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Изчисти всичко',
  CLEAR_COLOR_KEY: 'Изчисти цвят',
  CLOSE_WINDOW_KEY: 'Затвори прозореца',
  CLEAR_ALL_OBJECTS: 'Изчисти всички обекти',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE: 'Това ще премахне всичко обекти от фона.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Цвят',
  CONTINUE_KEY: 'Продължаване...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Поздравления!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: 'Още нямате акаунт в Pattern Design?',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Специален',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Влезте, за да видите цените на',
  CM_UNIT_KEY: 'см',
  CREATE_NEW: 'Създай нов',
  DESIGN_KEY: 'Дизайн',
  DELETE_KEY: 'Изтрий',
  DOCUMENT_COLORS: 'Цветове на документа',
  DONE: 'Готово!',
  DONE_KEY: 'Готово',
  DONT_SHOW_ALERT_KEY: 'Не показвай отново',
  DOWNLOAD_COLUMN_HEADER_KEY: 'Свали',
  DOWNLOAD_APP_TITLE_KEY: 'Можете да свалите приложението тук:',
  DOWNLOAD_LINK_KEY: 'Свалете HP Click безплатно тук',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Свалете HP SmartStream',
  DOWNLOAD_INSTR_KEY:
    'Уверете се, че HP Click е инсталиран, преди да продължите',
  DOWNLOAD_SMARTSTREAM_KEY: 'Свалете HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Внасяне от Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'Размерът на изображениет трябва да е по-малък от 1 GB. Приемаме pdf, png, jpg, svg и tiff файлове.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Търсене в Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Снимки от Dreamstime',
  DUPLICATE_KEY: 'Дублирай',
  EACH_ITEM_PRICE_KEY:
    'Вашият дизайн включва съдържание от един от нашите доставчици на премиумно съдържание. Цената на всеки елемент е описана отдолу.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Редактирай дизайн',
  EDIT_LOWERCASE_KEY: 'редактирай',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT: ' Грешка. Опитайте по-късно.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Имаше грешка при отварянето на качения PDF файл.',
  EMAIL_KEY: 'Имейл',
  EMAIL_ADDRESS_KEY: 'Имейл адрес:',
  EMAIL_CHECKBOX_MESSAGE:
    'Знам, че този човек разбира, че ще получи имейли от HP от мое име или този доставчик на услуги.',
  EXTRA_INFO_KEY: 'Допълнителна информация',
  EMAIL_NOTIFICATION:
    'Ще получите имейл след малко. Моля, изчакайте до 15-ина минути за обработка.',
  EMAIL_DIALOG_MESSAGE:
    'Напишете имейла на човека, с когото искате да споделите този дизайн.',
  ENTER_KEY: 'Влез',
  EXISTING_FOLDER_KEY: 'Съществуваща папка',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Проверете всички избрани неща, преди да продължите към завършването на поръчката',
  FINAL_CHECK_TITLE_KEY: 'Последна проверка',
  FINISH_KEY: 'Завърши',
  FINISH_LATER_KEY: 'Завърши по-късно',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Обърни огледално',
  FOR_KEY: 'за',
  FORGOT_PASSWORD_KEY: 'Забравена парола?',
  FOTOLIA_KEYWORDS_KEY: 'Ключови думи:',
  FOLDER_NAME: 'Име на папка',
  FOLDER_NAME_KEY: 'Име на папка:',
  FOLDER_ALREADY_EXIST_KEY: 'Името на тази папка вече съществува',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    'Току-що завършихте безплатния дизайн на плакат',
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, разбрах',
  GROUP_ALL_KEY: 'Групирай всички',
  GROUP_SCALE: 'Групов мащаб',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Дайте име на проекта си',
  HEIGHT_KEY: 'Височина',
  HELP_DESCRIPTION_KEY:
    'Нека ви покажем процеса на дизайн. Можете да гледате демонстрацията, колкото пъти искате, като кликнете на иконата за помощ.',
  HELP_KEY: 'Помощ',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'тук',
  HELP_IMPROVE_KEY:
    'Подобрете продуктивността си и ефективността на операторите и разширете с цветна продукция.',
  HIGH_QUALITY_KEY: 'Висококачествени',
  IMAGES_TITLE_KEY: 'ИЗОБРАЖЕНИЯ',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Внасяне',
  INCHES_COLUMN_HEADER_KEY: 'Инчове',
  INCHES_KEY: ' инчове',
  INCHES_UNIT_STRING_KEY: 'ин.',
  INVALID_EMAIL_ADDRESS_KEY: 'Невалиден имейл адрес',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'Невалидно име',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Файлът, който сте избрали, е прекалено голям. Максималният размер е 500mb.',
  INSUFFICIENT_CREDITS_KEY: 'Недостатъчен кредит',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Вдъхновение',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Това не е валиден формат на файл. Приемаме само pdf, jpg, png, svg и tif.',
  LANDSCAPE_KEY: 'Хоризонтален',
  LANGUAGE_LABLE_KEY: 'Език',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Научи повече',
  LEARN_THE_BASICS_KEY: 'Научете основите',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Използвайки този сайт, се съгласявате да бъдете обвързани с тези',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Този уебсайт спазва тези',
  LEGAL_FOOTER_MESSAGE3_KEY: 'и',
  LENGTH_STRING_IN_INCHES_KEY: 'ин',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'промени',
  LINK_READER_APP_KEY: 'приложението LinkReader',
  LINK_READER_APP_DESCRIPTION_KEY:
    'За да визуализирате съдържанието, което добавяте, свалете приложението LinkReader.',
  LOADING_KEY: 'Зареждане...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Заключи',
  LOGIN_KEY: 'Влез',
  LOGIN_PATTERN_DESIGN_KEY: 'Влез в Pattern design',
  LOGIN_SUBTITLE_KEY: 'Влезте, за да видите цените и инструкциите за плащане',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Влезте в Dreamstime ',
  LOGOUT_KEY: 'Излез',
  MATERIAL_TITLE_KEY: 'МАТЕРИАЛ',
  MATERIAL_STRING_KEY: 'Материал',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Метричен',
  MINIMUM_ZOOM_WARNING:
    'Този фон не може да бъде намален повече, защото сте стигнали до минималните височина и ширина, нужни да покрият стената ви.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Модел',
  MORE_INFO_TEXT_KEY: 'Повече информация',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'Моята работа',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Име:',
  NEXT_BUTTON_TITLE_KEY: 'NEXT',
  NEW_FOLDER_KEY: 'Нова папка',
  NO_SHADOW_KEY: 'Без сянка',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'ОБЕКТИ',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Поръчай мостра',
  ORDER_SAMPLE: 'Поръчай мостра',
  ORDER_SAMPLE_INFOLABEL_1:
    'Изберете частта от изображението, която искате да поръчате като мостра',
  ORDER_SAMPLE_INFOLABEL_2:
    'Ще получите имейл с увеличен изглед на проекта в действителен размер',
  ORDER_SAMPLE_INFOLABEL_3:
    'Това ще ви помогне да оцените качеството и резолюцията',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Поръчай мостра сега',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Получете имейл с увеличено изображение на проекта в действителен размер, за да прегледате качеството и резолюцията.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Други опции за печат',
  PASSWORD_KEY: 'Парола',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'шарки за',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'Неуспешно генериране на PDF. Опитайте отново.',
  PHOTOS_KEY: 'СНИМКИ',
  PHOTO: 'снимка',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Притежавам правата върху това изображение и се съгласявам с',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'Изображението трябва да е по-малко от 500MB. Приемаме само файлове във формат pdf, png, jpg, svg и tiff.',
  PIXEL_COLUMN_HEADER_KEY: 'Пиксел',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'см',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'напр. някои важни неща, които искате да кажете на печатницата',
  PLACEHOLDER_INCHES_STRING_KEY: 'ин',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Вертикален',
  POSITION: 'Позиция',
  PREMIUM_IMAGES_TITLE_KEY: 'Премиум изображения:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Запазете проекта си',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Проектът има промени, които трябва да бъдат запазени, преди да продължите.',
  PRICE_COLUMN_HEADER_KEY: 'Цена',
  PRINTER_SERIAL_NUMBER_KEY: 'Сериен номер на принтера*',
  PRINTING_ENABLE_DETAILS_KEY:
    'За да започнем печатането, ни трябват още няколко подробности',
  PRINTER_MODELS_KEY: 'Модели принтери*',
  PROCESSING_KEY: 'Обработване...',
  PROCESSING_ALERT_TXT:
    'Не затваряйте този прозорец, докато обработваме дизайна ви',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'Почти сте готови!',
  PROCESSING_FILE_TXT: 'Файлът ви се обработва.',
  PROCESSING_TIME_TXT:
    'Това може да отнеме известно време, понеже подреждаме творението ви, за да осигурим най-доброто качество на изображението',
  PROCESSING_ALERT_TXT3:
    'Вашият PDF ще бъде автоматично свален на компютъра ви',
  PROCESSING_ALERT_TXT4:
    'Не забравяйте, че можете да конфигурирате вашата JDF връзка за автоматизиране на настройките',
  PREMIUM_CONTENT_KEY: 'Премиум съдържание',
  PREVIEW_KEY: 'Преглед',
  PROFESSIONAL_USE_TITLE_KEY: 'професионална употреба.',
  PROJECT_NAME_KEY: 'Име на проекта',
  PROJECT_NAME: 'Име на проекта:',
  PROJECT_ALREADY_EXIST_KEY: 'Името на този проект вече съществува',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Името на този проект вече съществува',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Името на тази папка вече съществува',
  PIXELATION_WARNING_KEY: 'Предупреждение за пикселизиране',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Поради разделителната способност на качената от вас снимка кожата ви може да бъде изкривена или изкривена. За да сте сигурни, че няма размазване, моля, качете изображение с добро качество и избягвайте разтягането му. Ако сте доволни от визуализацията и искате да продължите, моля, продължете да изпращате.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: 'Задължителни полета',
  REQUIRED_FIELDS_TEXT_KEY: 'Задължителни полета',
  REQUIRED_STRING_KEY: 'ЗАДЪЛЖИТЕЛЕН',
  RECOLOR_KEY: 'Оцвети отново',
  RADICALLY_SIMPLE_KEY: 'Изключително лесен софтуеър за печат',
  RIPSELECTION_HEAD:
    'Това е първият ви път, изберете подходящ софтуеър за печат',
  RIPSELECTION_DESC:
    '>Изборът ви ще стане основен за бъдещо печатане. Можете да го промените по-късно в настройките',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Регистрирай се',
  REGISTER_NOW: 'Регистрирай се сега',
  REOLOR_KEY: 'Оцвети отново',
  REQUEST_SAMPLE_KEY: 'Поискай мостра',
  RESIZE_KEY: 'Смени размер',
  RESIZE_ARBITRARILY_KEY: 'Промени размера произволно',
  RESIZE_PROPORTIONALLY_KEY: 'Промени размера пропорционално',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Искане за цена',
  RIGHT_LOGO_TEXT_KEY: 'от',
  ROTATE_KEY: 'Завърти',
  ROTATE_LEFT_KEY: 'Завърти 90° наляво',
  ROTATE_RIGHT_KEY: 'Завърти 90° надясно',
  ROTATION_KEY: 'Завъртане',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Редове и колони',
  ROYALTY_FREE_KEY: 'без авторски права',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Запази',
  SAVING_KEY: 'Запазване...',
  SAVE_INSPIRATION: 'Запази вдъхновението',
  SAVE_TEMPLATE: 'Запази шаблон',
  SAVE_DIALOG_TITLE: 'Запазете проекта си',
  SAVE_PROJECT_NAME_KEY: 'Първо запазете проекта си',
  SAVEDIALOG_MESSAGE:
    'Влезте, за да запазите проекта си.Ако нямате акаунт, ще ви помогнем да си направите. Работата ви дотук няма да се загуби.',
  SEAMLESS_KEY: 'непрекъснати',
  SCALE_INFO_STRING_KEY:
    'Смени размера на изображението, за да пасне на дизайна',
  SCALE_KEY: 'Смени мащаба',
  SCALE_ALL_KEY: 'Смени мащаба на всичко',
  SCALE_TO_FILL_KEY: 'Увеличи за запълване',
  SEARCH_BUTTON_TITLE_KEY: 'Търсене',
  SELECT_CUSTOM_SIZE_KEY: 'Избери специален размер',
  SELECT_CUSTOM_KEY: 'Специален',
  SEARCH_TITLE: 'Търсене',
  SELECTED_IMAGE_KEY: 'Избрано изображение:',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Избери размер на плаката',
  SELECT_PRINTING_OPTION_KEY: 'Изберете предпочитаната опция за печат',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Изпрати ми инсталационни инструкции',
  SEND_TO_BACK_KEY: 'Изпрати на заден план',
  SEND_KEY: 'Изпрати',
  SEND_TO_PRINT_TITLE_KEY: 'Изпрати за печат',
  SET_SIZE_KEY: 'Задай размер',
  SETTINGS_KEY: 'Настройки',
  SETTINGS_UPPERCASE_KEY: 'НАСТРОЙКИ',
  SHARE_KEY: 'Сподели',
  SIGNED_IN_AS_KEY: 'Влязъл като',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Влезте или се регистрирайте, за да видите цените и инструкциите за плащане',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Пропусни',
  SOLID_COLORS_KEY: 'Плътни цветове',
  SQFT_UNIT_STRING_KEY: 'кв/фт',
  SQM_UNIT_STRING_KEY: 'м²',
  START_TOUR_KEY: 'Започни демонстрацията',
  STATUS_MSG: 'Файлът ви е изпратен за печат!',
  SUBMIT_BUTTON_KEY: 'Изпращане',
  SHARE_LINK_LABEL: 'Изберете типа линк, който искате да споделите',
  SHARE_EDIT_LINK: 'Редактирай линк',
  SHARE_VIEW_LINK: 'Виж линк',
  SHARE_YOUR_CREATION: 'Споделете творението си!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* Разстоянието за гледане на целта може да бъде сменено от настройките.',
  TERMS1_KEY: 'условия',
  TERMS2_KEY: 'HP изявление за поверителност',
  TERMS3_KEY: 'HP бележка за права върху личните данни',
  TERMS_OF_USE_KEY: 'Условия за употреба',
  TERMS_OF_USE: 'Условия за ползване.',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Плочка',
  TOTAL_KEY: 'ОБЩО',
  TOTAL_PRICE_KEY: 'Общо:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Благодаря',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Отключи',
  UNGROUP_KEY: 'Раздели групата',
  UPDATE_TEXT_KEY: 'Обнови',
  UPLOAD_KEY: 'Качи',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Потребителско име',
  USER_TYPE_TITLE_KEY: 'Какъв тип потребител сте вие*',
  UNTILE_KEY: 'Раздели плочки',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Валидност',
  VANILLA_LOGIN_DIALOG_KEY:
    'Присъединете се безплатно и запазете принтовете и дизайните си и вижте запазените си проекти',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'Това е преглед на дизайна си, проверете добре, преди да продължите или се върнете към "редактирай", за да направите промени.',
  VAT_KEY: 'ДДС',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'векторни',
  VIEW_FOTOLIA_KEY: 'Виж във Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Виж подробности за дизайна',
  VIEW_DESIGNER_PROFILE_KEY: 'Виж профила на дизайнера',
  VIEW_PRICE_KEY: 'Виж цена',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Плакати',
  WALL_SIZE_TEXT_KEY: 'Размер на стената',
  WARNING_KEY: 'Внимание',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Ширина',
  YOU_CAN_ALWAYS_ACCESS: 'Винаги можете да видите дизайните си в ',
  YOUR_NAME_KEY: 'Вашето име',
  YOUR_SELECTION_WILL_KEY: 'Изборът ви ще стане основен за бъдещо печатане.',
  YOUR_PROJECT_KEY: 'Вашият проект:',
  PROJECT_NAME_ERROR_TEXT: 'Дайте име на проекта си.',
  PROJECT_FOLDER_ERROR_TEXT: 'Дайте име на папката с проекта.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Минимално разстояние за гледане ',
  BACKGROUND_UPLOAD_KEY: 'фон',
  OBJECT_UPLOAD_KEY: 'обект',
  PHOTO_UPLOAD_KEY: 'снимка',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Не е намерено съдържание на dreamstime',
  NO_ELEMENT_ERROR_MESSAGE: 'Няма открит елемент.',
  NO_MORE_IMAGES_FOUND_KEY: 'Не са намерени повече изображения',
  NO_PATTERN_ERROR_MESSAGE: 'Няма открити шарки.',
  TOUR_DESCRIPTION_TEXT:
    'Нека ви покажем процеса на дизайн. Можете да гледате демонстрацията, колкото пъти искате, като кликнете на иконата за помощ.',
  TEXT_ANCHOR_MIDDLE: 'Center',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Смени на {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Съобщение:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'Това е обобщение на стойността на премиумното съдържание във вашия дизайн. {0} Като изберете "завърши", се съгласявате да платите съответната цена на доставчиците на съдържание.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will recieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Увеличилите сте до степен, при която печатното изображение може да излезе на пиксели, когато го гледате от  {0} {1} фута (настоящата печатна резолюция е {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Препоръчаното разстояние за гледане ще бъде {0} {1}. Ако не е подходящо, моля намалете мащаба на изображението или размера на стената. ',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Препоръчителният минимален размер на изображението трябва да е {0} x {1} пиксела.',
  UPLOAD_STATUS: '{0}% от {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Минималният размер е {0} (ш) на {1} (в).',
  MINIMUM_HEIGHT_KEY: 'Минималната височина е {0}.',
  MINIMUM_WIDTH_KEY: 'Минималната ширина е {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Максималните размери са {0} (ш) на {1} (в).',
  MAXIMUM_WIDTH_KEY: 'Максималната ширина е {0}.',
  MAXIMUM_HEIGHT_KEY: 'Максималната височина е {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'Въведете цифрови размери, по-големи от нула.',
  PROCESSING_FAILED: 'Обработката е неуспешна, моля опитайте по-късно.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'За съжаление криптираните PDF файлове не се поддържат.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Внасяне на файл {0} от {1}',
  DROPBOX_IMPORT_ERROR_HEADER: 'Имаше проблеми при внасянето на някои файлове',
  RECOLORING_KEY: 'Оцветяване...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Плътен цвят',
  AUTHENTICATE_DIALOG_TITLE: 'Този източник на съдържание е защитен с парола',
  AUTHENTICATE_FAILED_MESSAGE: 'Неуспешна проверка!',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Не поддържаме PDF файлове с повече от една страница.',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Проект',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Този шаблон за вдъхновение се предлага с размер по подразбиране {0} X {1} {2}. Размерът на вашата страница ще бъде автоматично променен, за да се побере този шаблон.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'Моля, въведете задължителните полета',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'Your details',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  CAUTION_FOR_LAPTOP_SELECTION:
    'За да имате компютърна кожа, перфектно адаптирана към вашата, трябва да изберете точния модел, съответстващ на покупката, както се вижда във фактурата.',
  NOTICE_KEY: 'известие:',
  RESTART_PROJECT_ALERT_TITLE: 'Restart a project ?',
  DISCARD_ALERT_MESSAGE: 'Your current project will be discarded',
  RESTART: 'Restart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE:
    'Предупреждение за размера на страницата!',
  MODIFY_SIZE_WARNING:
    'Ако искате да промените размера на този дизайн, можете да го направите в раздела „Настройки“. Елементите на дизайна може да изискват редактиране, за да се приспособят към желаните от вас размери.',
  RANDOMIZE_KEY: 'Randomize',
  MATERIAL_CHOICE_APPLIED: 'Приложен е избор на материал.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'удостоверение за',
  AUTHENTICITY_STRING: 'автентичност',
  PLEASE_WAIT: 'Моля Изчакай',
  PROTECTING_YOUR_DATA: 'защита на вашите данни...',
  SEARCH_YOUR_LAPTOP_KEY: 'Търсете вашия лаптоп', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Ами сега! Не можахме да намерим никакви лаптопи за вашето търсене.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Сериен номер',
  LOCKED_PROJECT: 'Заключен проект',
  LOCKED_MESSAGE:
    'Проектът вече е поръчан и не може да бъде променян. Можете само да го прегледате.',
  EXPIRED_PROJECT: 'Изтекъл проект',
  EXPIRED_MESSAGE: 'Този проект е изтекъл.',
  DELETED_PROJECT: 'Изтрит проект',
  DELETED_MESSAGE: 'Този проект е изтрит.',
  CHOOSE_GROUP_TYPE: 'Изберете {0} тип',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Въведете числа по-големи от нула.',
  SIZE_KEY: 'Размер',
  DISTANCE_FROM_KEY: 'Разстояние от',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Мебели',
  FIXTURES_KEY: 'Приспособления',
  ADD_A_WALL_KEY: 'Добавете стена',
  SELECT_A_WALL_KEY: 'Изберете стена',
  LEFT_KEY: 'Ляво',
  RIGHT_KEY: 'Дясно',
  DELETE_WALL_KEY: 'Изтрий стена',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Избери тип платно',
  MAXIMUM_WALL_SIZE_KEY: 'Максималният размер на стената е {0}кв.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'Височината на платното надхвърля височината на стената.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'Ширината на платното надхвърля ширината на стената.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Максималният брой колони за тази ширина е {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Максималният брой редове за тази височина е {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Ширината на стената е по-малка от ширината на платното.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Стената трябва да има минимална ширина от {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Стената трябва да има минимална височина от {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Височината на стената е по-малка от височината на платното.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Максималната височина на стената е {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Огледало',
  NATURAL_KEY: 'Натурален',
  ROWS_KEY: 'Редове',
  COLUMNS_KEY: 'Колони',
  DEFAULT_WALL_SIZE_KEY: 'Основен размер на стената',
  EDIT_KEY: 'Редактирай',
  TOP_KEY: 'Нагоре',
  BOTTOM_KEY: 'Долна част'
};
